const router = {}

// 足球-杯赛-赛程
const FootballCupScheduleIndex = () =>
  import(
    /* webpackChunkName: "footballCupScheduleIndex" */ '@platfrom/football/cup_schedule/index.vue'
  )

// 足球-亚洲世预赛-赛程
const FootballAsianPreCupScheduleIndex = () =>
  import(
    /* webpackChunkName: "footballAsianPreCupScheduleIndex" */ '@platfrom/football/cup_schedule/asianPreCup_index.vue'
  )

// 足球-杯赛-赛程详情
const FootballCupScheduleDetailIndex = () =>
  import(
    /* webpackChunkName: "footballCupScheduleDetailIndex" */ '@platfrom/football/cup_scheduleDetail/index.vue'
  )
const FootballCupScheduleDetailPreMatch = () =>
  import(
    /* webpackChunkName: "footballCupScheduleDetailPreMatch" */ '@platfrom/football/cup_scheduleDetail/childPage/preMatch.vue'
  )

const FootballCupScheduleDetailLineup = () =>
  import(
    /* webpackChunkName: "footballCupScheduleDetailLineup" */ '@platfrom/football/cup_scheduleDetail/childPage/lineup.vue'
  )
const  FootballCupScheduleDetailAIForwardLooking = () =>
  import(
    /* webpackChunkName: "footballCupScheduleDetailLineup" */ '@platfrom/football/cup_scheduleDetail/childPage/AIForwardLooking.vue'
    )

const FootballCupScheduleDetailAnalysis = () =>
  import(
    /* webpackChunkName: "footballCupScheduleDetailAnalysis" */ '@platfrom/football/cup_scheduleDetail/childPage/analysis.vue'
  )

const FootballCupScheduleDetailStatistics = () =>
  import(
    /* webpackChunkName: "footballCupScheduleDetailStatistics" */ '@platfrom/football/cup_scheduleDetail/childPage/statistics.vue'
  )

// 足球-杯赛-球队
const FootballCupTeamIndex = () =>
  import(
    /* webpackChunkName: "footballCupTeamListIndex" */ '@platfrom/football/cup_team/index.vue'
  )

// 足球-杯赛-球队详情
const FootballCupTeamDetailIndex = () =>
  import(
    /* webpackChunkName: "footballCupTeamDetailIndex" */ '@platfrom/football/cup_teamDetail/index.vue'
  )
const FootballCupTeamDetailTeamData = () =>
  import(
    /* webpackChunkName: "footballCupTeamDetailTeamData" */ '@platfrom/football/cup_teamDetail/childPage/teamData.vue'
  )

const FootballCupTeamDetailPlayerList = () =>
  import(
    /* webpackChunkName: "footballCupTeamDetailPlayerList" */ '@platfrom/football/cup_teamDetail/childPage/playerList.vue'
  )

const FootballCupTeamDetailMatchRecord = () =>
  import(
    /* webpackChunkName: "footballCupTeamDetailMatchRecord" */ '@platfrom/football/cup_teamDetail/childPage/matchRecord.vue'
  )

// 足球-杯赛-积分榜
const FootballCupLeagueTableIndex = () =>
  import(
    /* webpackChunkName: "footballCupLeagueTableIndex" */ '@platfrom/football/cup_leagueTable/index.vue'
  )

// 足球-杯赛-淘汰赛
const FootballCupKnockoutRoundsIndex = () =>
  import(
    /* webpackChunkName: "footballCupKnockoutRoundsIndex" */ '@platfrom/football/cup_knockoutRounds/index.vue'
  )

// 足球-杯赛-数据-数据概览
const FootballCupRecordDataOverviewIndex = () =>
  import(
    /* webpackChunkName: "footballCupRecordDataOverviewIndex" */ '@platfrom/football/cup_record/dataOverview.vue'
  )
// 足球-杯赛-数据-球队数据
const FootballCupRecordTeamDataIndex = () =>
  import(
    /* webpackChunkName: "footballCupRecordTeamDataIndex" */ '@platfrom/football/cup_record/teamData.vue'
  )
// 足球-杯赛-数据-球员数据
const FootballCupRecordPlayerDataIndex = () =>
  import(
    /* webpackChunkName: "footballCupRecordPlayerDataIndex" */ '@platfrom/football/cup_record/playerData.vue'
  )

// 足球-杯赛-球员
const FootballCupPlayerIndex = () =>
  import(
    /* webpackChunkName: "footballCupPlayerIndex" */ '@platfrom/football/cup_player/index.vue'
  )
// 足球-杯赛-球员详情
const FootballCupPlayerDetailIndex = () =>
  import(
    /* webpackChunkName: "footballCupPlayerDetailIndex" */ '@platfrom/football/cup_playerDetail/index.vue'
  )

// 足球-杯赛-场馆
const FootballCupSportsHallIndex = () =>
  import(
    /* webpackChunkName: "footballCupSportsHallIndex" */ '@platfrom/football/cup_sportsHall/index.vue'
  )

// 足球-杯赛-播出单
const FootballCupBroadcastListIndex = () =>
  import(
    /* webpackChunkName: "commonPageBroadcastListIndex" */ '@platfrom/commonPage/broadcastList/index.vue'
  )

// 足球-杯赛-数据包装
const FootballCupDataPackagListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageDataPackagListIndex" */ '@platfrom/commonPage/dataPackagList/index.vue'
  )

// 马拉松-节目单
const FootballCupProgramListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageProgramListIndex" */ '@platfrom/commonPage/programList/index.vue'
  )

// 足球-杯赛-H5组件
const FootballCupH5CompIndex = () =>
  import(
    /* webpackChunkName: "footballCupH5CompIndex" */ '@platfrom/football/cup_h5Comp/index.vue'
  )

router.FootballCupScheduleIndex = FootballCupScheduleIndex
router.FootballAsianPreCupScheduleIndex = FootballAsianPreCupScheduleIndex
router.FootballCupScheduleDetailIndex = FootballCupScheduleDetailIndex
router.FootballCupScheduleDetailPreMatch = FootballCupScheduleDetailPreMatch
router.FootballCupScheduleDetailLineup = FootballCupScheduleDetailLineup
router.FootballCupScheduleDetailAIForwardLooking = FootballCupScheduleDetailAIForwardLooking
router.FootballCupScheduleDetailAnalysis = FootballCupScheduleDetailAnalysis
router.FootballCupScheduleDetailStatistics = FootballCupScheduleDetailStatistics
router.FootballCupTeamIndex = FootballCupTeamIndex
router.FootballCupTeamDetailIndex = FootballCupTeamDetailIndex
router.FootballCupTeamDetailTeamData = FootballCupTeamDetailTeamData
router.FootballCupTeamDetailPlayerList = FootballCupTeamDetailPlayerList
router.FootballCupTeamDetailMatchRecord = FootballCupTeamDetailMatchRecord
router.FootballCupLeagueTableIndex = FootballCupLeagueTableIndex
router.FootballCupKnockoutRoundsIndex = FootballCupKnockoutRoundsIndex
router.FootballCupRecordDataOverviewIndex = FootballCupRecordDataOverviewIndex
router.FootballCupRecordTeamDataIndex = FootballCupRecordTeamDataIndex
router.FootballCupRecordPlayerDataIndex = FootballCupRecordPlayerDataIndex
router.FootballCupPlayerIndex = FootballCupPlayerIndex
router.FootballCupPlayerDetailIndex = FootballCupPlayerDetailIndex
router.FootballCupSportsHallIndex = FootballCupSportsHallIndex
router.FootballCupBroadcastListIndex = FootballCupBroadcastListIndex
router.FootballCupProgramListIndex = FootballCupProgramListIndex
router.FootballCupH5CompIndex = FootballCupH5CompIndex
router.FootballCupDataPackagListIndex = FootballCupDataPackagListIndex

export default router
